import React, { useState } from 'react';
import {
  Box, Card, CardContent, TextField, Button,
  Typography, Alert, CircularProgress, Link
} from '@mui/material';
import { login, register } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [form, setForm] = useState({
    email: '', password: '', full_name: '', phone: '', organization: ''
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(form.email, form.password);
      loginUser(res.data.user, res.data.access_token, res.data.refresh_token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await register(form);
      setSuccess('Registration successful! Your account is pending admin approval.');
      setMode('login');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #5BA4D4 0%, #3A7EAA 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2
    }}>
      <Card sx={{ width: '100%', maxWidth: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img
              src="/logo.png"
              alt="Furry AI"
              style={{ width: 80, height: 80, objectFit: 'contain' }}
            />
            <Typography variant="h5" sx={{ mt: 1, color: 'primary.main' }}>
              Furry AI
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Animal Vaccination Management
            </Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={mode === 'login' ? handleLogin : handleRegister}>
            {mode === 'register' && (
              <>
                <TextField
                  fullWidth label="Full Name" name="full_name"
                  value={form.full_name} onChange={handleChange}
                  margin="normal" required
                />
                <TextField
                  fullWidth label="Phone" name="phone"
                  value={form.phone} onChange={handleChange}
                  margin="normal"
                />
                <TextField
                  fullWidth label="Organization" name="organization"
                  value={form.organization} onChange={handleChange}
                  margin="normal"
                />
              </>
            )}
            <TextField
              fullWidth label="Email" name="email" type="email"
              value={form.email} onChange={handleChange}
              margin="normal" required
            />
            <TextField
              fullWidth label="Password" name="password" type="password"
              value={form.password} onChange={handleChange}
              margin="normal" required
            />
            <Button
              fullWidth variant="contained" type="submit"
              disabled={loading} sx={{ mt: 2, py: 1.5 }}
            >
              {loading
                ? <CircularProgress size={24} color="inherit" />
                : mode === 'login' ? 'Sign In' : 'Register'
              }
            </Button>
          </form>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            {mode === 'login' ? (
              <Typography variant="body2">
                No account?{' '}
                <Link component="button"
                  onClick={() => { setMode('register'); setError(''); }}>
                  Register here
                </Link>
              </Typography>
            ) : (
              <Typography variant="body2">
                Have an account?{' '}
                <Link component="button"
                  onClick={() => { setMode('login'); setError(''); }}>
                  Sign in
                </Link>
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
